import React from 'react';
import { ToggleButton, ToggleButtonGroup, ToggleButtonProps, Typography, styled, Theme, SxProps } from '@mui/material';

type ToggleButton = {
  label: string | React.ReactNode;
  length: number;
  value: string | number | boolean;
  state?: boolean | undefined;
  sx?: SxProps<Theme> | undefined;
  handleButtonClick?: () => void;
};

type ButtonProps = ToggleButtonProps & {
  buttons: ToggleButton[];
  handleClick: (selectedValues: string[]) => void;
};

const ButtonToggle = styled(ToggleButton)(({ theme }) => ({
  width: 130,
  height: 40,
  border: '1px solid',
  borderRadius: 32,
  '&.MuiToggleButton-root.Mui-selected': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    borderRadius: 32,
    border: 'none',
  },
  '&.MuiToggleButton-root': {
    color: theme.palette.common.white,
    borderRadius: 32,
    borderLeft: '1px solid',
  },
  '&:not(:last-of-type)': {
    marginRight: 10,
  },
}));

const FilterButtonGroup: React.FC<ButtonProps> = ({ buttons, handleClick }) => {
  const [selected, setSelected] = React.useState<(string | number | boolean)[]>([]);

  const handleSelected = (event: React.MouseEvent<HTMLElement>, newSelection: string[] | null) => {
    setSelected(newSelection ?? []);
    handleClick(newSelection ?? []);
  };

  return (
    <ToggleButtonGroup
      value={selected}
      exclusive={false}
      onChange={handleSelected}
      aria-label="text alignment"
      sx={{ height: 'fit-content' }}>
      {buttons.map((btn, idx) => (
        <ButtonToggle
          key={idx}
          sx={btn.sx}
          value={btn.value}
          onClick={() => {
            if (btn && btn.handleButtonClick) btn.handleButtonClick();
          }}>
          <Typography textTransform={'capitalize'} fontWeight={'500'}>
            {btn.label} ({btn.length})
          </Typography>
        </ButtonToggle>
      ))}
    </ToggleButtonGroup>
  );
};

export default FilterButtonGroup;
